<template>
  <div class="d-flex flex-column" style="height: 100%;">
    <Section>
      <LeadPurchaseHistoryItem :item="currentHistoryItem" />
    </Section>

    <Section>
      <v-form ref="form" @submit.prevent="submitClick">
        <v-select
          v-model="reason"
          :items="reasons"
          label="What is the problem?"
          outlined dense
          :rules="[ required ]"
        />

        <v-textarea
          v-model="description"
          label="Please share any details that may explain your issue."
          outlined dense hide-details="auto"
          :rules="[ required ]"
        />

        <div class="text-center mt-3" style="font-size: 12px;">
          Please see our
          <router-link :to="{ name: 'you/legal/dispute' }">Dispute Policy</router-link>
          if you have any questions.
        </div>

        <div class="d-flex justify-center mt-4 mb-3d">
          <v-btn @click="cancelClick">Cancel</v-btn>
          <v-btn class="ml-3" color="primary" type="submit">Continue</v-btn>
        </div>
      </v-form>
    </Section>
    <ErrorOverlay
      title="Payment Method Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </div>
</template>

<script>
import { ErrorOverlay } from '@/components/pages'

import LeadPurchaseHistoryItem from '../components/HistoryItems/LeadPurchaseItem'
import { Section } from '@/components/pages'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@/lib/validations'


export default {
  name: 'HistoryDisputeCreate',

  components: { ErrorOverlay, LeadPurchaseHistoryItem, Section },

  props: {
    lead_id: {
      type: [ Number, String ],
      required: true,
    },
  },

  data: () => ({
    reason: '',
    description: '',

    reasons: [
      'Lead is not in my coverage area.',
      'The service requested is wrong.',
      'This lead is a duplicate.',
      'This customer contact number is unreachable.',
      'This lead has an incorrect building type.',
      'Other...'
    ],

    // error handling
    loading: true,
    error_dialog: false,
    error_message: '',

    // validation rules
    required,
  }),

  computed: {
    ...mapGetters('billing', ['currentHistoryItem']),
  },

  methods: {
    ...mapActions('billing', ['loadCurrentHistoryItem']),
    ...mapActions('leads', ['createDispute']),

    cancelClick() {
      this.$router.back()
    },

   async submitClick() {
      if (this.$refs.form.validate()) {
        const { lead_id, reason, description } = this

        this.loading = true
        const result = await this.createDispute({ lead_id, reason, description })
        this.loading = false

        if (result.ok) {
          // this.$router.replace({ name: 'billing/history/dispute' })
          this.$router.replace({ name: 'history/dispute/confirm' })
        } else {
          this.error_message = result.error
          this.error_dialog = true
        }
      }
    },
  },

  created() {
    const { lead_id } = this

    this.loading = true
    this.loadCurrentHistoryItem({ lead_id })
    this.loading = false
  }
}
</script>